import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  totalElements: 0,
  totalPages: 0,
  error: "",
}

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // find-all
      .addCase(findAllSession.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(findAllSession.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.data = action.payload.page
        state.totalElements = action.payload.totalElements
        state.totalPages = action.payload.totalPages
      })
      .addCase(findAllSession.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const findAllSession = createAsyncThunk(
  "/session/find-all",
  async ({ start = 0, limit = 75, user = "%", jwt }, thunkAPI) => {
    try {
      const endpoint = `/etc/session?start=${start}&limit=${limit}&user=%25${user}%25`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue(data)
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const getSession = (state) => state.session
export default sessionSlice.reducer
